import axios from 'axios';
import { CHECKOUT_SETTING } from './constants';

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/users_controller.rb#L34
 * @return {Axios.IPromise<U>}
 */
export function getCheckoutSetting(query) {
  return axios.get(CHECKOUT_SETTING, {
    params: { query },
    withCredentials: true,
  });
}
